/**
 * Feature flag constants
 * These control the availability of features in the application
 */

export const FEATURE_FLAGS = {
    /** AI-powered features (e.g., AI-generated FiBu export definitions) */
    AI_FEATURES: import.meta.env.VITE_FEATURE_FLAGS_AI_FEATURES === 'true',
    /** External applications menu entry under Systemverwaltung */
    EXTERNAL_APPLICATIONS: import.meta.env.VITE_FEATURE_FLAGS_EXTERNAL_APPLICATIONS === 'true',
    /** Action event log menu entry under Systemverwaltung */
    ACTION_EVENT_LOGS: import.meta.env.VITE_FEATURE_FLAGS_ACTION_EVENT_LOGS === 'true',
    /** Order staging (Auftragseingang) entry in the orders list */
    STAGING: import.meta.env.VITE_FEATURE_FLAGS_STAGING === 'true',
    /** Container section (Containerdienst) on the order mask */
    CONTAINER_SERVICE: import.meta.env.VITE_FEATURE_FLAGS_CONTAINER_SERVICE === 'true',
} as const;
